import React, { useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Navbar from './Client_navbar';
import ProtectedRoute from '../../components/ProtectedRoute';
import { Container } from 'react-bootstrap';
import Client_dash from './Client_dash';
import Client_home from './Client_home';
import Client_profile from './Client_profile';
import Wedding_related_stuff from './Wedding_related_stuff';
import Web_mobile_appform from './Web_mobile_appform';
import Marketing_form from './Marketing_form';
import Onboarding_Form from './Onboarding_Form';
import OnboardingTour from '../../components/onboarding/OnboardingTour';
import clientOnboardingSteps from '../../components/onboarding/clientOnboardingSteps';
import {
    ONBOARDING_CHAIN_PHASE,
    getOnboardingChainResumePath,
    handleOnboardingChainFinish,
} from '../../components/onboarding/onboardingStorage';

const Client_dashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const resumePath = getOnboardingChainResumePath(location.pathname);
        if (resumePath) navigate(resumePath);
    }, [location.pathname, navigate]);

    const handleDashboardTourFinish = (status) => {
        const nextPath = handleOnboardingChainFinish(ONBOARDING_CHAIN_PHASE.DASHBOARD, status);
        if (nextPath) navigate(nextPath);
    };

    return (
        <Container fluid className="wrapper p-0">
            <Navbar />
            <OnboardingTour
                steps={clientOnboardingSteps}
                namespace="client"
                onFinish={handleDashboardTourFinish}
            />
            <Routes>

                <Route path="Client_dash" element={<ProtectedRoute element={Client_home} allowedRoles={['SuperAdmin','Client']} />} />
                <Route path="Client_home" element={<ProtectedRoute element={Client_home} allowedRoles={['SuperAdmin','Client']} />} />
                <Route path="Client_profile" element={<ProtectedRoute element={Client_profile} allowedRoles={['SuperAdmin','Client']} />} />
                <Route path="wedding_related" element={<ProtectedRoute element={Wedding_related_stuff} allowedRoles={['SuperAdmin','Client']} />} />
                <Route path="web_mobile_app" element={<ProtectedRoute element={Web_mobile_appform} allowedRoles={['SuperAdmin','Client']} />} />
                <Route path="marketing" element={<ProtectedRoute element={Marketing_form} allowedRoles={['SuperAdmin','Client']} />} />


                <Route path="Onboarding_Form/:type" element={<ProtectedRoute element={Onboarding_Form} allowedRoles={['SuperAdmin','Client']} />} />

            </Routes>
        </Container>
    )
};

export default Client_dashboard;
